import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
export var appBorders = {
    backrsDropShadowBorders: {
        black: {
            border: "3px solid ".concat(appColors.neutral.black),
            boxShadow: "5px 5px 0px 0px ".concat(appColors.neutral.black),
        },
        blue: {
            border: "3px solid ".concat(appColors.color.blue1),
            boxShadow: "5px 5px 0px 0px ".concat(appColors.color.blue1),
        },
    },
    backrsBorders: {
        black: {
            border: "3px solid ".concat(appColors.neutral.black),
        },
        blue: {
            border: "3px solid ".concat(appColors.color.blue1),
        },
    },
};
